/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillDetailCommonVo
 */
export interface BillDetailCommonVo {
    /**
     * ID
     * @type {number}
     * @memberof BillDetailCommonVo
     */
    id?: number;
    /**
     * 账单ID
     * @type {number}
     * @memberof BillDetailCommonVo
     */
    billId?: number;
    /**
     * 通用明细内容（JSON字符串）
     * @type {string}
     * @memberof BillDetailCommonVo
     */
    detailContent?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof BillDetailCommonVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof BillDetailCommonVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the BillDetailCommonVo interface.
 */
export function instanceOfBillDetailCommonVo(value: object): value is BillDetailCommonVo {
    return true;
}

export function BillDetailCommonVoFromJSON(json: any): BillDetailCommonVo {
    return BillDetailCommonVoFromJSONTyped(json, false);
}

export function BillDetailCommonVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillDetailCommonVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'billId': json['billId'] == null ? undefined : json['billId'],
        'detailContent': json['detailContent'] == null ? undefined : json['detailContent'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function BillDetailCommonVoToJSON(json: any): BillDetailCommonVo {
    return BillDetailCommonVoToJSONTyped(json, false);
}

export function BillDetailCommonVoToJSONTyped(value?: BillDetailCommonVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'billId': value['billId'],
        'detailContent': value['detailContent'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

